import React from 'react';

function GeneralPhysicianLogin() {
    return (
        <div>
        <h1>General Physician Login</h1>
        {/* Contenido de la página */}
        </div>
    );
}

export default GeneralPhysicianLogin;